import apiService from "./apiService";
import { ICustomerDTO } from "./profile";
import { IStudentDTO } from "./students";
import { IPagination, IPaginationParams } from "./common";
import { ISOString } from "@sizdevteam1/funjoiner-uikit";

export type WaitlistRecordStatus =
  | "open"
  | "completed"
  | "awaiting_payment"
  | "cancelled";

export type WaitlistRecordType = "PROGRAM_RECORD" | "SESSION_RECORD";
interface WaitlistRecordDTOBase {
  id: string;
  program_id: string;
  location_id: number;
  funbox_id: string;
  schedule_set_id: string;
  status: WaitlistRecordStatus;
  program_type_name: string;
  schedule_set_name: string;
  location_name: string;
  start: ISOString;
  end: ISOString;
  invoice_info: {
    order_id: number;
  } | null;
  student_id: number;
  student: IStudentDTO;
  waitlist_policy: string;
  created_at: ISOString;
}

export interface ProgramWaitlistRecordDTO extends WaitlistRecordDTOBase {
  type: "PROGRAM_RECORD";
}

export interface SessionWaitlistRecordDTO extends WaitlistRecordDTOBase {
  type: "SESSION_RECORD";
}

export type WaitListRecordDTO =
  | ProgramWaitlistRecordDTO
  | SessionWaitlistRecordDTO;

export interface CombinedSessionWaitlistRecordsDTO {
  student_id: number;
  program_id: string;
  records: SessionWaitlistRecordDTO[];
  program_type_name: string;
  schedule_set_name: string;
  location_name: string;
  schedule_set_id: string;
  funbox_id: string;
  location_id: string;
  start: ISOString;
  end: ISOString;
}

export interface AddToWaitlistForProgramDTO {
  program_id: string;
  student_ids: number[];
}

export interface AddToWaitlistForSessionsDTO {
  session_ids: string[];
  student_ids: number[];
}

export function isProgramWaitlistRecord(
  item: WaitListRecordDTO,
): item is ProgramWaitlistRecordDTO {
  return "type" in item && item.type === "PROGRAM_RECORD";
}

export const getRecords = (
  searchParams: {
    studentId: number | null;
  },
  paginationParams: IPaginationParams = { limit: 25, offset: 0 },
): Promise<IPagination<WaitListRecordDTO>> =>
  apiService.get("/customer_api/v2/waitlists/", {
    searchParams: { ...searchParams, ...paginationParams },
  });

export const addToWaitlist = (
  scheduleSetId: string,
  dto: AddToWaitlistForProgramDTO | AddToWaitlistForSessionsDTO,
): Promise<ICustomerDTO> =>
  apiService.post(`/customer_api/v2/waitlists/${scheduleSetId}/add`, {
    data: dto,
  });

export const removeFromWaitlist = (
  schedule_set_id: string,
  record_ids: string[],
): Promise<ICustomerDTO> =>
  apiService.post(`/customer_api/v2/waitlists/${schedule_set_id}/remove`, {
    data: {
      ids: record_ids,
    },
  });
